import {TemplateType} from "../generated/graphql";
import i18n from "../services/i18n";

export const renderTitle = (type: TemplateType | undefined) => {
    // console.log("=========> type: ", type);
    switch (type) {
        case "Warning":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.warning();
        case "BookingConfirmation":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.bookingConfirmation();
        case "WaitingListConfirmation":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.waitingListConfirmation();
        case "InterestListConfirmation":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.interestListConfirmation();
        case "Transfer":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.transfer();
        case "DunningReminder":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.dunningReminder();
        case "DunningLevel1":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.dunningLevel1();
        case "DunningLevel2":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.dunningLevel2();
        case "DunningLevel3":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.dunningLevel3();
        case "Tarif595Receipt":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.tarif595Receipt();
        case "SettlementConfirmation":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.invoice();
        case "Reminder":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.courseMemory();
        case "SettledBookingCancellation":
            return i18n.containers.templates.EmailTemplates.defaultTemplates.cancelInvoice();
        default:
            return i18n.containers.templates.EmailTemplates.defaultTemplates.bookingConfirmation();
    }
};
